import { Inbox, Phone, Mail } from "lucide-react";

export default function EnquiriesPanel({ items }) {
  if (!items) {
    return (
      <div data-testid="admin-enquiries-loading" className="border border-white/10 bg-[#0A0A0A] p-16 text-center text-zinc-500 text-sm">
        Loading enquiries…
      </div>
    );
  }
  if (items.length === 0) {
    return <EmptyState message="No enquiries yet." />;
  }
  return (
    <div className="border border-white/10 overflow-hidden">
      <div className="hidden lg:grid grid-cols-12 gap-4 bg-[#0A0A0A] px-6 py-4 text-[10px] tracking-[0.25em] uppercase text-zinc-500 font-bold border-b border-white/10">
        <div className="col-span-2">When</div>
        <div className="col-span-2">Name</div>
        <div className="col-span-2">Contact</div>
        <div className="col-span-2">Service</div>
        <div className="col-span-3">Route · Vehicle</div>
        <div className="col-span-1 text-right">Date</div>
      </div>
      <div data-testid="admin-enquiries-list">
        {items.map((e) => (
          <EnquiryRow key={e.id} e={e} />
        ))}
      </div>
    </div>
  );
}

function EnquiryRow({ e }) {
  const created = e.created_at ? new Date(e.created_at) : null;
  const vehicle = [e.vehicle_make, e.vehicle_model].filter(Boolean).join(" ").trim();
  return (
    <div
      data-testid={`admin-enquiry-${e.id}`}
      className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-6 py-5 border-b border-white/5 hover:bg-[#0A0A0A] transition-colors"
    >
      <div className="lg:col-span-2 text-zinc-400 text-sm">
        {created ? (
          <>
            <div className="text-white font-semibold">{created.toLocaleDateString("en-GB")}</div>
            <div className="text-xs text-zinc-500">
              {created.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
            </div>
          </>
        ) : (
          "—"
        )}
      </div>
      <div className="lg:col-span-2">
        <div className="text-white font-semibold">{e.name}</div>
      </div>
      <div className="lg:col-span-2 text-sm space-y-1">
        <a href={`tel:${e.phone}`} className="flex items-center gap-2 text-zinc-300 hover:text-white">
          <Phone className="w-3.5 h-3.5 text-[#E60000]" />
          {e.phone}
        </a>
        <a href={`mailto:${e.email}`} className="flex items-center gap-2 text-zinc-300 hover:text-white break-all">
          <Mail className="w-3.5 h-3.5 text-[#E60000]" />
          {e.email}
        </a>
      </div>
      <div className="lg:col-span-2">
        <span className="text-[10px] tracking-[0.2em] uppercase text-[#E60000] font-bold border border-[#E60000]/40 px-2 py-1">
          {e.service}
        </span>
      </div>
      <div className="lg:col-span-3 text-sm text-zinc-300">
        <div>
          <span className="text-zinc-500">From</span> {e.pickup_location}{" "}
          <span className="text-zinc-500">→</span> {e.dropoff_location}
        </div>
        {vehicle && <div className="text-xs text-zinc-500 mt-1">Vehicle: {vehicle}</div>}
        {e.message && (
          <div className="text-xs text-zinc-400 mt-2 italic line-clamp-3">
            &ldquo;{e.message}&rdquo;
          </div>
        )}
      </div>
      <div className="lg:col-span-1 text-right text-xs text-zinc-400">{e.preferred_date || "—"}</div>
    </div>
  );
}

function EmptyState({ message = "Nothing yet." }) {
  return (
    <div data-testid="admin-empty-state" className="border border-white/10 bg-[#0A0A0A] p-16 text-center">
      <Inbox className="w-10 h-10 text-zinc-600 mx-auto" />
      <h3 className="font-display text-2xl font-bold mt-4">{message}</h3>
      <p className="text-zinc-400 mt-2 text-sm">New activity will appear here in real time.</p>
    </div>
  );
}
